"use strict";

exports.__esModule = true;
exports.generateActivityId = generateActivityId;
var _Utils = require("../../Utils");
/**
 * Filter the given list of activities using the given value filter term
 */
function generateActivityId(activity, plantStateActivities) {
  var startId = (0, _Utils.convertToID)(activity.name);
  var id = startId;
  var increment = 1;
  while (plantStateActivities.activities.find(function (activity) {
    return activity.id === id;
  }) !== undefined) {
    id = startId + "-" + increment;
    increment++;
  }
  return id;
}